<template>
	<div class="main">
		<img src="../../assets/images/heitiane.png"/>
	</div>
</template>

<script>
	export default {
		
	}
</script>

<style>
	.main {
		margin: 0 auto;
		width: 1200px;
	}
	
	.main img {
		width: 1200px;
	}
</style>